/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { SessionWalletCreateResponseData } from "./SessionWalletCreateResponseData";
import * as t from "io-ts";

/**
 * Form data needed to create a credit card input form
 */

// required attributes
const SessionWalletCreateResponseR = t.interface({
  orderId: t.string,

  sessionData: SessionWalletCreateResponseData
});

// optional attributes
const SessionWalletCreateResponseO = t.partial({});

export const SessionWalletCreateResponse = t.intersection(
  [SessionWalletCreateResponseR, SessionWalletCreateResponseO],
  "SessionWalletCreateResponse"
);

export type SessionWalletCreateResponse = t.TypeOf<
  typeof SessionWalletCreateResponse
>;
